'use client'

import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { CustomFlowbiteTheme, Dropdown, DropdownItem } from 'flowbite-react'

const customDropdownTheme: CustomFlowbiteTheme['dropdown'] = {
  floating: {
    target:
      'rounded-lg enabled:hover:bg-white enabled:hover:text-gray-900 :ring-gray-100 focus:text-gray-900',
  },
}

const sortFields = [{ name: 'Recently Added', value: 'recently_added' }]

export default function Sort() {
  const searchParams = useSearchParams()

  const handleSort = (term: string) => {
    const params = new URLSearchParams(searchParams)
    if (params.has('orderBy')) {
      params.delete('orderBy')
    } else {
      params.set('orderBy', term)
    }

    window.history.replaceState(null, '', `?${params.toString()}`)
  }

  return (
    <Dropdown
      theme={customDropdownTheme}
      className="bg-gray-50"
      label="Sort"
      color="gray"
      pill
    >
      {sortFields.map((field, index) => (
        <DropdownItem key={index} onClick={() => handleSort(field.value)}>
          {field.name}
        </DropdownItem>
      ))}
    </Dropdown>
  )
}
